/*
 * Cart guard. Confirmed bug, 19 Aug 2026.
 *
 * Cart calls ask Shopify to re-render a section by id, and that id is baked into the page
 * at render time. It changes when a theme is published. A page the customer already had
 * (back/forward cache, a tab open since before the publish, an edge-cached copy) asks for
 * an id that no longer exists. Verified: Shopify answers 200, ADDS THE ITEM, and returns
 * sections: { 'sections--<old id>__header': null }. The theme renders that null, throws,
 * and its catch shows 'There was an error while updating your cart. Please try again.'
 *
 * The message is false - the boot is already in the cart. The customer taps again and ends
 * up with three line items. That is what was reported.
 *
 * Two layers, deliberately:
 *
 *   1. Strip null sections from cart responses before the theme sees them. A missing key is
 *      skipped harmlessly; a null value is what throws. Clean, but it needs to wrap fetch,
 *      and Shopify scripts (trekkie, preloads, shop-cart-sync) load before this file and may
 *      already hold the native fetch - so it is not relied on alone.
 *
 *   2. Guard the outcome in the DOM, which does not depend on fetch. Swallow repeat taps for
 *      a few seconds so a false error cannot become three line items, and hide the error if
 *      the cart actually did change.
 *
 * A guard, not a repair. The real fix is for the theme to tolerate a null section, and to
 * stop pinning a build-specific section id into pages that outlive the build.
 *
 * ES5 with feature guards, for old iOS Safari.
 */
(function () {
    window.__dicoCartGuard = 1;

    /* ---- layer 1: strip null sections ---- */
    if (window.fetch) {
        var orig = window.fetch;
        window.fetch = function () {
            var args = arguments, url = '';
            try { url = String((args[0] && args[0].url) || args[0] || ''); } catch (e) { url = ''; }
            if (url.indexOf('/cart/') === -1) { return orig.apply(this, args); }
            return orig.apply(this, args).then(function (res) {
                if (!res || !res.ok || typeof res.clone !== 'function') { return res; }
                var ct = '';
                try { ct = res.headers.get('content-type') || ''; } catch (e) { ct = ''; }
                if (ct.indexOf('json') === -1) { return res; }
                return res.clone().text().then(function (txt) {
                    var data;
                    try { data = JSON.parse(txt); } catch (e) { return res; }
                    if (!data || !data.sections || typeof data.sections !== 'object') { return res; }
                    var removed = false, k;
                    for (k in data.sections) {
                        if (Object.prototype.hasOwnProperty.call(data.sections, k) && !data.sections[k]) {
                            delete data.sections[k];
                            removed = true;
                        }
                    }
                    if (!removed) { return res; }
                    window.__dicoCartGuard = 2;
                    try {
                        return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers: res.headers });
                    } catch (e) { return res; }
                }, function () { return res; });
            });
        };
    }

    /* ---- layer 2: DOM outcome guard ---- */
    var busyUntil = 0;

    function findAdd(node) {
        while (node && node.nodeType === 1) {
            if (node.nodeName === 'BUTTON' && node.getAttribute('name') === 'add') { return node; }
            node = node.parentNode;
        }
        return null;
    }

    function cartCount(cb) {
        try {
            var x = new XMLHttpRequest();
            x.open('GET', '/cart.js?t=' + new Date().getTime(), true);
            x.onreadystatechange = function () {
                if (x.readyState === 4) {
                    var n = null;
                    try { n = JSON.parse(x.responseText).item_count; } catch (e) { n = null; }
                    cb(n);
                }
            };
            x.send();
        } catch (e) { cb(null); }
    }

    function hideFalseError() {
        var nodes = document.querySelectorAll('[class*=error], [class*=Error], .form-status, .product-form__error-message-wrapper');
        for (var i = 0; i < nodes.length; i++) {
            var t = (nodes[i].textContent || '');
            if (/error while updating your cart/i.test(t)) {
                nodes[i].style.display = 'none';
                nodes[i].setAttribute('aria-hidden', 'true');
            }
        }
    }

    document.addEventListener('click', function (ev) {
        var btn = findAdd(ev.target);
        if (!btn) { return; }

        var now = new Date().getTime();
        if (now < busyUntil) {
            // A tap already went through and we are still waiting to see the result.
            // Swallow this one so a false error cannot become a duplicate line item.
            ev.preventDefault();
            ev.stopImmediatePropagation();
            return false;
        }
        busyUntil = now + 4000;

        cartCount(function (before) {
            if (before === null) { return; }
            setTimeout(function () {
                cartCount(function (after) {
                    if (after !== null && after > before) { hideFalseError(); }
                    busyUntil = 0;
                });
            }, 2200);
        });
    }, true);
})();
